<template>
  <div>
    <nav class="woocommerce-breadcrumb" itemprop="breadcrumb">
      <a href="/dashboard">Dashboard</a> / <span> Sync </span> /
      <span> Select Groups </span>
    </nav>
    <sync-steps method="groups"></sync-steps>

    <div class="container">
      <div class="mx-2">
        <div class="sync-select-groups__heading">
          <h2 class="flow-heading mt-5 mb-3">Select the groups you want to sync</h2>

          <p>
            This is two-way sync with your connected CRM. Data will be synced across both platforms. Select which groups
            you would like to sync below.
          </p>
        </div>

        <flow-search
          @input="search = $event"
          @toggle-all="onToggleAll"
          :search="search"
          placeholder="Search by group name"
          :everySelected="everySelected"
        ></flow-search>

        <form action="/sync/confirm/" method="POST" class="text-center">
          <div class="flow-groups-container">
            <flow-groups
              :groups="filteredGroups"
              :selectedGroupsIds="selectedGroupsIds"
              @toggle-item="onToggleGroup"
              full
            ></flow-groups>
            <input type="hidden" name="selectedGroupsIds" :value="stringifyIds" />
            <input type="hidden" name="method" value="groups" />
          </div>

          <div>
            <a class="btn btn-lg btn-outline-primary mr-2" href="/sync/select-method/">Back</a>
            <button type="submit" class="btn btn-lg btn-primary" :disabled="!selectedGroupsIds.length">Continue</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import SyncSteps from '../components/sync/SyncSteps';
import FlowGroups from '../components/shared/FlowGroups';
import FlowSearch from '../components/shared/FlowSearch';
import flowGroups from '../mixins/flowGroups.js';

export default {
  name: 'sync-select-groups-page',
  mixins: [flowGroups],
  components: {
    SyncSteps,
    FlowGroups,
    FlowSearch,
  },
  props: {
    groups: {
      type: String,
      required: true,
    },
    excludedGroup: {
      type: String,
    },
  },
  computed: {
    allGroups() {
      const groups = JSON.parse(this.groups);
      return groups.filter(group => group.name !== this.excludedGroup);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../sass/web/_variables.scss';
.sync-select-groups {
  &__heading {
    max-width: 733px;
    margin: 0 auto;
  }
}

.flow-groups-container {
  max-height: 272px;
  margin: 30px auto;
}
</style>
